import { useCallback, useRef, useState } from 'react';
import { getCompanyCurrencies } from 'services/Configuration/companyCurrenciesService';

export function useFetchCompanyCurrencies() {
  const [currencies, setCurrencies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const abortControllerRef = useRef(null);

  const fetchCurrencies = useCallback(async (params = {}) => {
    if (abortControllerRef.current) abortControllerRef.current.abort();
    const controller = new AbortController();
    abortControllerRef.current = controller;
    setIsLoading(true);
    setError(null);
    try {
      const data = await getCompanyCurrencies(params, controller.signal);
      setCurrencies(data.data ?? data);
    } catch (err) {
      if (err.name === 'AbortError' || err.name === 'CanceledError') return;
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { currencies, isLoading, error, fetchCurrencies };
}
